module.exports = __webpack_public_path__ + "static/media/Cross bite11.cb4c752a.png";